import { useMemo } from 'react';
import { Timeline } from 'framework/ViewTypes/embeddable';
import type { TimelineEditor } from 'framework/ViewTypes/embeddable';
import type usePositionProfileTimeline from './usePositionProfileTimeline';
import { getPositionProfileTimelineConfig } from './config';

interface PositionProfileTimelineProps {
  editor: TimelineEditor;
  canManageNotes: boolean;
  timeline: ReturnType<typeof usePositionProfileTimeline>;
}

const PositionProfileTimeline = ({ canManageNotes, timeline, editor }: PositionProfileTimelineProps) => {
  const config = useMemo(() => getPositionProfileTimelineConfig(canManageNotes), [canManageNotes]);

  return <Timeline {...timeline} config={config} editor={editor} />;
};

export default PositionProfileTimeline;
